import BaseService from './BaseService'
import UserModel from '../models/UserModel'
import AdminModel from '../models/AdminModel'
import GroupModel from '../models/GroupModel'
import SettingModel from '../models/SettingModel'
import ControllerModel from '../models/ControllerModel'
import FarmModel from '../models/FarmModel'
import KindTypeModel from '../models/KindTypeModel'
import WardModel from '../models/WardModel'
import DistrictModel from '../models/DistrictModel'
import StateModel from '../models/StateModel'
import FarmHasKindTypeModel from '../models/FarmHasKindTypeModel'
import RelationshipImageModel from '../models/RelationshipFileModel'
import ImageModel from '../models/FileModel'
import UnitModel from '../models/UnitModel'
import EquipmentModel from '../models/EquipmentModel'
import EquipmentHasUnitsModel from '../models/EquipmentHasUnitsModel'
import CsUnitModel from '../models/CsUnitModel'
import HistoryCheckModel from '../models/HistoryCheckModel'
import ObjBoxModel from '../models/ObjBoxModel'
import ImportModel from '../models/ImportModel'
import recordModel from '../models/recordModel'
import ImportBoxModel from '../models/ImportBoxModel'
import exportModel from '../models/exportModel'
import ExchangeModel from '../models/ExchangeModel'
import KindModel from '../models/KindModel'
import KindInBoxModel from '../models/KindInBoxModel'
import FarmHasUnitsModel from '../models/FarmHasUnitsModel'
import CompanyModel from '../models/CompanyModel'
import FarmKindProductivityModel from '../models/FarmKindProductivity'
import UnitHasKindTypeModel from '../models/UnitHasKindTypeModel'
import UsersRoleModel from '../models/UsersRoleModel'
import WorkModel from '../models/WorkModel'
import TypeWorkModel from '../models/TypeWorkModel'
import StatusModel from '../models/StatusModel'
import FarmHasWorkModel from '../models/FarmHasWorkModel'
import UnitHasWorkModel from '../models/UnitHasWorkModel'
import WorkAssignUserModel from '../models/WorkAssignUserModel'
import ReportModel from '../models/ReportModel'
import WaterParametersModel from '../models/WaterParametersModel'
import WaterParametersValueModel from '../models/WaterParametersValueModels'
import DashboardModel from '../models/DashboardModel'
import FarmHasEquipmentModel from '../models/FarmHasEquipmentModel'
import NotificationModel from '../models/NotificationModel'
import NotificationUsersModel from '../models/NotificationUsersModel'
import NotificationFarmModel from '../models/NotificationFarmModel'
import GroupUserModel from '../models/GroupUserModel'
import GroupRoleModel from '../models/GroupRoleModel'
import UnitWaterModel from '../models/UnitWater'
import AccountsModel from '../models/Accounts'
import UnitHasUsersModel from '../models/UnitHasUsersModel'
import RecordDetailRealModel from '../models/RecordDetailRealModel'

export default {
    services: {
      'setting': {
        'service': new BaseService(new SettingModel()),
        'model': new SettingModel()
      },
      'view_admin': {
        'model': new AdminModel(),
        'service': new BaseService(new AdminModel())
      },
      'group': {
        'model': new GroupModel(),
        'service': new BaseService(new GroupModel())
      },
      'users': {
        'model': new UserModel(),
        'service': new BaseService(new UserModel())
      },
      'controller': {
        'service': new BaseService(new ControllerModel()),
        'model': new ControllerModel()
      },
      'farm': {
        'service': new BaseService(new FarmModel()),
        'model': new FarmModel()
      },
      'kind_type': {
        'service': new BaseService(new KindTypeModel()),
        'model': new KindTypeModel()
      },
      'state': {
        'service': new BaseService(new StateModel()),
        'model': new StateModel()
      },
      'district': {
        'service': new BaseService(new DistrictModel()),
        'model': new DistrictModel()
      },
      'ward': {
        'service': new BaseService(new WardModel()),
        'model': new WardModel()
      },
      'farm_has_kind_type': {
        'service': new BaseService(new FarmHasKindTypeModel()),
        'model': new FarmHasKindTypeModel()
      },
      'relationship_file': {
        'service': new BaseService(new RelationshipImageModel()),
        'model': new RelationshipImageModel()
      },
      'file': {
        'service': new BaseService(new ImageModel()),
        'model': new ImageModel()
      },
      'unit': {
        'service': new BaseService(new UnitModel()),
        'model': new UnitModel()
      },
      'cs_unit': {
        'service': new BaseService(new CsUnitModel()),
        'model': new CsUnitModel()
      },
      'equipment': {
        'service': new BaseService(new EquipmentModel()),
        'model': new EquipmentModel()
      },
      'equipment_has_units': {
        'service': new BaseService(new EquipmentHasUnitsModel()),
        'model': new EquipmentHasUnitsModel()
      },
      'history_check': {
        'service': new BaseService(new HistoryCheckModel()),
        'model': new HistoryCheckModel()
      },
      'obj_box': {
        'service': new BaseService(new ObjBoxModel()),
        'model': new ObjBoxModel()
      },
      'import': {
        'service': new BaseService(new ImportModel()),
        'model': new ImportModel()
      },
      'record': {
        'service': new BaseService(new recordModel()),
        'model': new recordModel()
      },
      'record_detail': {
        'service': new BaseService(new ImportBoxModel()),
        'model': new ImportBoxModel()
      },
      'export': {
        'service': new BaseService(new exportModel()),
        'model': new exportModel()
      },
      'exchange': {
        'service': new BaseService(new ExchangeModel()),
        'model': new ExchangeModel()
      },
      'kind': {
        'service': new BaseService(new KindModel()),
        'model': new KindModel()
      },
      'kind_in_box': {
        'service': new BaseService(new KindInBoxModel()),
        'model': new KindInBoxModel()
      },
      'farm_has_unit': {
        'service': new BaseService(new FarmHasUnitsModel()),
        'model': new FarmHasUnitsModel()
      },
      'company': {
        'service': new BaseService(new CompanyModel()),
        'model': new CompanyModel()
      },
      'farm_kind_productivity': {
        'service': new BaseService(new FarmKindProductivityModel()),
        'model': new FarmKindProductivityModel()
      },
      'unit_has_kind_types': {
        'service': new BaseService(new UnitHasKindTypeModel()),
        'model': new UnitHasKindTypeModel()
      },
      'users_role': {
        'service': new BaseService(new UsersRoleModel()),
        'model': new UsersRoleModel()
      },
      'work': {
        'service': new BaseService(new WorkModel()),
        'model': new WorkModel()
      },
      'type_work': {
        'service': new BaseService(new TypeWorkModel()),
        'model': new TypeWorkModel()
      },
      'status': {
        'service': new BaseService(new StatusModel()),
        'model': new StatusModel()
      },
      'farm_has_work': {
        'service': new BaseService(new FarmHasWorkModel()),
        'model': new FarmHasWorkModel()
      },
      'unit_has_work': {
        'service': new BaseService(new UnitHasWorkModel()),
        'model': new UnitHasWorkModel()
      },
      'work_assign_user': {
        'service': new BaseService(new WorkAssignUserModel()),
        'model': new WorkAssignUserModel()
      },
      'report': {
        'service': new BaseService(new ReportModel()),
        'model': new ReportModel()
      },
      'water_parameters': {
        'service': new BaseService(new WaterParametersModel()),
        'model': new WaterParametersModel()
      },
      'water_parameters_value': {
        'service': new BaseService(new WaterParametersValueModel()),
        'model': new WaterParametersValueModel()
      },
      'dashboard': {
        'service': new BaseService(new DashboardModel()),
        'model': new DashboardModel()
      },
      'farm_has_equipment': {
        'service': new BaseService(new FarmHasEquipmentModel()),
        'model': new FarmHasEquipmentModel()
      },
      'notification': {
        'service': new BaseService(new NotificationModel()),
        'model': new NotificationModel()
      },
      'notification_users': {
        'service': new BaseService(new NotificationUsersModel()),
        'model': new NotificationUsersModel()
      },
      'notification_farm': {
        'service': new BaseService(new NotificationFarmModel()),
        'model': new NotificationFarmModel()
      },
      'group_user': {
        'service': new BaseService(new GroupUserModel()),
        'model': new GroupUserModel()
      },
      'group_role': {
        'service': new BaseService(new GroupRoleModel()),
        'model': new GroupRoleModel()
      },
      'unit_water': {
        'service': new BaseService(new UnitWaterModel()),
        'model': new UnitWaterModel()
      },
      'accounts': {
        'service': new BaseService(new AccountsModel()),
        'model': new AccountsModel()
      },
      'unit_has_users': {
        'service': new BaseService(new UnitHasUsersModel()),
        'model': new UnitHasUsersModel()
      },
      'record_detail_real': {
        'service': new BaseService(new RecordDetailRealModel()),
        'model': new RecordDetailRealModel()
      },
    },
    getModel(modelName) {
      return this.services[modelName].model
    },
    getList(modelName, params) {
      return this.services[modelName].service.getListQuery(params);
    },
    countData(modelName) {
      return this.services[modelName].service.countDataQuery();
    },
    updateData(modelName) {
        return this.services[modelName].service.updateDataQuery();
    },
    insertData(modelName) {
      return this.services[modelName].service.insertDataQuery();
    },
    deleteData(modelName) {
      return this.services[modelName].service.deleteDataQuery();
    },
    getByMyId(modelName,params) {
      return this.services[modelName].service.getByMyIdQuery(params);
    },
};
